"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorLayerSourceFactory = void 0;
var VectorLayerSource_StrategyBounds_1 = require("./VectorLayerSource_StrategyBounds");
var VectorLayerSource_StrategyAll_1 = require("./VectorLayerSource_StrategyAll");
var VectorLayerSource_OgcFilterStrategy_1 = require("./VectorLayerSource_OgcFilterStrategy");
var VectorLayerSource_StrategyMvc_1 = require("./VectorLayerSource_StrategyMvc");
var VectorLayerStrategy_1 = require("../VectorLayerStrategy");
var VectorLayerSource_StrategyMvcCluster_1 = require("./VectorLayerSource_StrategyMvcCluster");
var GeoJsonClusterFeatureLoader_1 = require("./loaders/GeoJsonClusterFeatureLoader");
var VectorLayerSource_OgcFilterAllStrategy_1 = require("./VectorLayerSource_OgcFilterAllStrategy");
var VectorLayerSourceFactory = /** @class */ (function () {
    function VectorLayerSourceFactory(_logger, _loaderExtentsBehaviour, _featureLoader, _featureAdd) {
        var _this = this;
        this._logger = _logger;
        this._loaderExtentsBehaviour = _loaderExtentsBehaviour;
        this._featureLoader = _featureLoader;
        this._featureAdd = _featureAdd;
        this.getVectorLayerSource = function (map, layer, wfsParams, featureAdd, url, urlParams) {
            var vls;
            //use the default if there is no override
            if (featureAdd === null) {
                featureAdd = _this._featureAdd;
            }
            switch (layer.group.strategy) {
                case VectorLayerStrategy_1.VectorLayerStrategy.All:
                    vls = new VectorLayerSource_StrategyAll_1.VectorLayerSource_StrategyAll(map, layer, url, _this._featureLoader, featureAdd, _this._logger, wfsParams, urlParams);
                    break;
                case VectorLayerStrategy_1.VectorLayerStrategy.Bbox:
                    vls = new VectorLayerSource_StrategyBounds_1.VectorLayerSource_StrategyBounds(map, layer, url, _this._logger, _this._loaderExtentsBehaviour, _this._featureLoader, featureAdd, wfsParams, urlParams);
                    break;
                case VectorLayerStrategy_1.VectorLayerStrategy.OgcFilterBbox:
                    vls = new VectorLayerSource_OgcFilterStrategy_1.VectorLayerSource_OgcFilterStrategy(map, layer, url, _this._logger, _this._loaderExtentsBehaviour, _this._featureLoader, featureAdd, wfsParams, urlParams);
                    break;
                case VectorLayerStrategy_1.VectorLayerStrategy.OgcFilterAll:
                    vls = new VectorLayerSource_OgcFilterAllStrategy_1.VectorLayerSource_OgcFilterAllStrategy(map, layer, url, _this._logger, _this._featureLoader, featureAdd, wfsParams, urlParams);
                    break;
                case VectorLayerStrategy_1.VectorLayerStrategy.Mvc:
                    vls = new VectorLayerSource_StrategyMvc_1.VectorLayerSource_StrategyMvc(map, layer, url, _this._logger, _this._loaderExtentsBehaviour, _this._featureLoader, featureAdd);
                    break;
                case VectorLayerStrategy_1.VectorLayerStrategy.MvcCluster:
                    vls = new VectorLayerSource_StrategyMvcCluster_1.VectorLayerSource_StrategyMvcCluster(map, layer, url, _this._logger, _this._loaderExtentsBehaviour, new GeoJsonClusterFeatureLoader_1.GeoJsonClusterFeatureLoader(), featureAdd);
                    break;
            }
            return vls;
        };
    }
    VectorLayerSourceFactory.prototype.instance = function (map, layer, wfsParams, featureAdd, url, urlParams) {
        return this.getVectorLayerSource(map, layer, wfsParams, featureAdd, url, urlParams);
    };
    return VectorLayerSourceFactory;
}());
exports.VectorLayerSourceFactory = VectorLayerSourceFactory;
//# sourceMappingURL=VectorLayerSourceFactory.js.map